module.exports = __webpack_public_path__ + "assets/panels/powermax-pro-7285ede11d13d27873ad51873709ad88.svg";